<template>
  <div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      openId: '',
      attach1: ''
    }
  },
  created() {
    console.log("openid", this.getQueryString('openid'))
    if (this.getQueryString('openid')) {
      this.openId = this.getQueryString('openid')
    }
    // let attach = Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;
    // localStorage.setItem('attach', JSON.stringify({ data: attach, expires: Date.now() + 86400000 }))
    // if(this.getQueryString('attach')){
    //   this.attach1 = this.getQueryString('attach')
    // }
    if (!this.openId) {
      window.location.href = `https://w.llchefu.com/site/get-openid`
    } else {
      let url = localStorage.getItem("url")
      let withdrawType = localStorage.getItem("withdrawType")
      if (withdrawType == 'cardWithdraw') {
        window.location.href = `${url}&openid=${this.openId}`
      } else {
        window.location.href = `${url}?openid=${this.openId}`
      }

      // this.$router.push({
      //   path: "/tixian",
      //   query: {
      //     openId: this.openId,
      //     attach: this.attach1
      //   }
      // })
    }


  },
  mounted() {
  },
  methods: {
    getParameterByName(name) {
      name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
      var regexS = "[\\?&]" + name + "=([^&#]*)";
      var regex = new RegExp(regexS);
      var results = regex.exec(window.location.search);
      if (results == null) {
        return "";
      } else {
        return decodeURIComponent(results[1].replace(/\+/g, " "));
      }
    },
    getQueryString(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      if (window.location.hash.indexOf("?") < 0) return null;
      let r = window.location.hash.split("?")[1].match(reg);
      if (r != null) return decodeURIComponent(r[2]);
      return null;
    },
    back() {

    },
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/account/withdrawal.vue